export enum Operation{
  ADDITION = 'ADDITION',
  SUBTRACTION = 'SUBTRACTION',
  MULTIPLICATION = 'MULTIPLICATION',
  DIVISION = 'DIVISION',
  SAME = 'SAME',
  PERCENTAGE = 'PERCENTAGE'
}
